import PropTypes from 'prop-types';

import { getPagePath, trans } from '@spotahome/soyuz/client';

import { ACTIONS } from '../constants';

import styles from './LoginSignupModalTermsAndConditions.module.scss';

const LoginSignupModalTermsAndConditions = ({ action }) => {
  const content = trans(`authentication.${action}.terms_and_conditions`, {
    terms: getPagePath('externals.terms-and-conditions'),
    privacy: getPagePath('externals.privacy-policies')
  });

  return (
    <div
      // eslint-disable-next-line react/no-danger
      className={styles['login-signup-modal-terms-and-conditions__translated']}
      dangerouslySetInnerHTML={{
        __html: `${content}. ${trans('authentication.recaptcha.message')}`
      }}
    />
  );
};

LoginSignupModalTermsAndConditions.propTypes = {
  action: PropTypes.oneOf(ACTIONS).isRequired
};

export default LoginSignupModalTermsAndConditions;
